const en = {
	cancel: "Cancel",
	select: "Select",
	rightClickToDelete: "Right click to delete",
	customColors: "Custom colors",
	addNewColor: "Add new color"
};

export default en;